import { Button } from "@/components/flexkit/Button";
import { Heading2 } from "@/components/podkit/typography/Headings";
import { useState, type FC } from "react";
import IconCirclePlus from "central-icons/IconCirclePlus";
import { withGitpodSize } from "@/assets/icons/utils";
import { ServiceAccountGitAuthenticationsList } from "@/components/settings/organization/service-accounts/ServiceAccountGitAuthenticationsList";
import { AddGitAuthenticationDialog } from "@/components/settings/organization/service-accounts/AddGitAuthenticationDialog";
import { useCreateServiceAccountAccessToken, useGetServiceAccount } from "@/queries/service-account-queries";
import { ErrorMessage } from "@/components/ErrorMessage";
import { serviceAccountHeaders } from "@/api";

const IconCirclePlusWithGitpodSize = withGitpodSize(IconCirclePlus);

export const ServiceAccountGitAuthentications: FC<{ serviceAccountId: string }> = ({ serviceAccountId }) => {
    const [showAddDialog, setShowAddDialog] = useState(false);

    const { data: serviceAccount, error: getServiceAccountError } = useGetServiceAccount({ serviceAccountId });

    // The service account access token is created using the logged in identity
    const { data: serviceAccountAccessToken, error: serviceAccountAccessTokenError } =
        useCreateServiceAccountAccessToken({ serviceAccountId });

    // These headers can be used to perform requests on behalf of the service account
    const headers = serviceAccountAccessToken
        ? serviceAccountHeaders({ serviceAccountId, serviceAccountAccessToken: serviceAccountAccessToken })
        : undefined;

    const onAddAuthentication = () => {
        setShowAddDialog(true);
    };

    return (
        <>
            <div className="flex flex-col gap-2">
                <div className="flex min-h-7 flex-grow items-center justify-between gap-2">
                    <Heading2 className="text-lg font-medium">Git Authentications</Heading2>
                    <Button
                        variant="secondary"
                        LeadingIcon={IconCirclePlusWithGitpodSize}
                        size="xs"
                        onClick={() => onAddAuthentication()}
                        data-tracking-id="add"
                        disabled={!serviceAccount || !serviceAccountAccessToken}
                    >
                        Add
                    </Button>
                </div>
                <ErrorMessage error={getServiceAccountError} />
                <ErrorMessage error={serviceAccountAccessTokenError} />
                <ServiceAccountGitAuthenticationsList headers={headers} onAddAuthentication={onAddAuthentication} />
            </div>

            {serviceAccount && headers && (
                <AddGitAuthenticationDialog
                    open={showAddDialog}
                    onClose={() => setShowAddDialog(false)}
                    serviceAccount={serviceAccount}
                    headers={headers}
                />
            )}
        </>
    );
};
